var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticFireAlarmDevice01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.92,13.92H2.08V2.08h11.83V13.92z M2.58,13.42h10.83V2.58H2.58V13.42z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.41,
    y: 5.24,
    transform: "matrix(0.9999 -0.0158 0.0158 0.9999 -0.1323 0.0904)",
    className: "st2",
    width: 0.5,
    height: 6.37
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.37,
    y: 5.24,
    className: "st2",
    width: 2.76,
    height: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.59,7.91 5.85,7.91 5.85,7.41 8.09,7.41 8.09,5.24 11.61,5.24 11.61,5.74 8.59,5.74  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.12,11.65v-0.5c2.05,0,2.95-0.66,3.1-1.22c0.12-0.46,0.05-0.86-0.21-1.2C9.6,8.21,8.8,7.91,7.8,7.91v-0.5 c1.15,0,2.1,0.37,2.6,1.01c0.35,0.46,0.46,1.03,0.3,1.63C10.44,11.05,9.1,11.65,7.12,11.65z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticFireAlarmDevice01);
export default __webpack_public_path__ + "static/media/AutomaticFireAlarmDevice-01.5a56e5c89c831dcaa46b421675bc22bb.svg";
export { ForwardRef as ReactComponent };